export default __webpack_public_path__ + "static/cigna-1eabce51976759e6adbd8a326039629d.svg";